import React, {useEffect, useLayoutEffect} from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import {useNavigate, useNavigationType} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {
	fetchBranchReceivableInfo,
	fetchDetailBranchPageScroll,
	updateReceivableInfo,
	updateBranchReceivableInfoList
} from "redux/slices/sales/salesSlice";

import {getToday} from "utils/date";
import {isBranchPermission} from "utils/define";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "../period/SummaryInfo";
import BranchDetailList from "./BranchDetailList";
import PullToRefreshing from "components/common/PullToRefreshing";



/**
 * [전지점 누적 미수금 조회]
 */

export const BranchDetail = () => {
	const today = getToday();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const navigationType = useNavigationType();

	let {
		searchPartner,
		searchBranch,
		searchDate,
		searchPeriodType,
		searchFilter,
		data,
		isLoading,
		isError
	} = useSelector(state => state.sales.branchReceivableInfo);
	const partnerInfo = useSelector(state => state.partner);

	useEffect(() => {
		if(!searchPartner) {
			dispatch(fetchBranchReceivableInfo({
				searchPartner : partnerInfo.seqPartner,
				searchBranch : partnerInfo.seqPartnerBranch,
				searchDate : today
			}));
		}
		if(!isBranchPermission(partnerInfo)) {
			navigate("/sales");
			return null;
		}
	}, []);

	useEffect(() => {
		const isUpdate = (
			!data || navigationType != "POP" || (
				searchPartner != data.searchInfo.searchPartner ||
				searchBranch != data.searchInfo.searchBranch ||
				today != data.searchInfo.searchDate
			)
		);
		if(isUpdate) eventHandler.update();
	}, [searchPartner, searchBranch]);

	useLayoutEffect(() => {
		return () => {
			dispatch(fetchDetailBranchPageScroll("store"));
		};
	}, []);

	const eventHandler = {
		update : () => {
			dispatch(updateReceivableInfo({
				searchPartner : searchPartner,
				searchBranch : searchBranch,
				branchUseYn : "Y",
				searchDate : today
			}, fetchBranchReceivableInfo));
		},
		pullToRefresh: () => {
			return new Promise((resolve) => {
				setTimeout(() => {
					eventHandler.update();
					dispatch(updateBranchReceivableInfoList(false));
					resolve();
				}, 700);
			});
		}
	};

	const render = () => {
		return (
			<PullToRefresh
				onRefresh={eventHandler.pullToRefresh}
				resistance={2}
				pullingContent={<></>}
				refreshingContent={<PullToRefreshing />}
			>
				<MainLayout
					withHeader={true}
					headerProps={{
						withBackButton : true,
						centerTitle : "전 지점 누적 미수금"
					}}
					backgroundColor="white"
					withBottomTab={false}
				>
					<SummaryInfo
						mode="receivable"
						title="현재까지 누적 미수금"
						data={{
							totalAmount : (data || {}).receivableAmount || 0
						}}
						color="red"
						isLoading={isLoading}
						isError={isError}
						onRefresh={eventHandler.update}
					/>
					<BranchDetailList />
				</MainLayout>
			</PullToRefresh>
		);
	};

	return render();
};

export default BranchDetail;